function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreppyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "527px",
    height: "468px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M -0.5,-0.5 C 175.167,-0.5 350.833,-0.5 526.5,-0.5C 526.5,155.5 526.5,311.5 526.5,467.5C 350.833,467.5 175.167,467.5 -0.5,467.5C -0.5,311.5 -0.5,155.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 86.5,4.5 C 202.5,4.33333 318.5,4.5 434.5,5C 479.538,13.3718 505.705,40.2051 513,85.5C 513.667,183.5 513.667,281.5 513,379.5C 508.235,413.587 490.402,438.087 459.5,453C 450.49,456.586 441.156,458.919 431.5,460C 317.5,460.667 203.5,460.667 89.5,460C 50.091,454.589 23.9243,433.089 11,395.5C 9.74369,390.552 8.74369,385.552 8,380.5C 7.33333,281.833 7.33333,183.167 8,84.5C 15.9321,39.736 42.0988,13.0694 86.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000101",
    d: "M 91.5,18.5 C 142.405,18.1693 193.238,18.5027 244,19.5C 243.861,81.7164 243.361,143.883 242.5,206C 169.164,206.833 95.8311,206.667 22.5,205.5C 21.3398,167.542 21.1731,129.542 22,91.5C 25.0471,58.4592 41.8804,35.6259 72.5,23C 78.8568,20.9923 85.1901,19.4923 91.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 259.5,18.5 C 286.167,18.5 312.833,18.5 339.5,18.5C 339.336,123.834 339.003,229.167 338.5,334.5C 311.5,334.5 284.5,334.5 257.5,334.5C 257.631,229.096 258.297,123.762 259.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 354.5,18.5 C 379.502,18.3334 404.502,18.5 429.5,19C 464.691,23.8583 487.191,43.3583 497,77.5C 498.631,86.1065 499.298,94.7732 499,103.5C 450.904,104.664 402.737,104.83 354.5,104C 354.483,75.708 354.483,47.208 354.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 122.5,32.5 C 161.682,30.6618 190.182,46.9951 208,81.5C 221.991,119.033 214.491,151.533 185.5,179C 149.253,205.232 113.253,204.898 77.5,178C 46.7337,146.897 41.2337,111.73 61,72.5C 75.5751,49.968 96.0751,36.6347 122.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 140.5,38.5 C 142.308,38.4914 143.975,38.9914 145.5,40C 148.535,43.3702 151.868,46.3702 155.5,49C 159.619,49.1432 163.619,49.8099 167.5,51C 170.104,57.2684 174.771,60.9351 181.5,62C 184.606,65.6323 186.773,69.799 188,74.5C 190.257,76.0456 192.424,77.7123 194.5,79.5C 194.981,86.1104 197.814,91.4438 203,95.5C 204.868,107.505 204.868,119.505 203,131.5C 199.181,134.935 197.515,139.269 198,144.5C 193.089,147.989 189.923,152.656 188.5,158.5C 185.995,160.253 183.329,161.753 180.5,163C 178.554,166.881 175.888,170.214 172.5,173C 167.003,175.245 162.003,178.245 157.5,182C 149.614,184.489 141.614,186.656 133.5,188.5C 127.428,186.075 121.095,184.908 114.5,185C 111.5,183.333 108.5,181.667 105.5,180C 100.392,179.726 95.7251,178.226 91.5,175.5C 90.2939,172.921 88.9606,170.421 87.5,168C 83.8333,166.333 80.1667,164.667 76.5,163C 73.9825,158.109 72.1492,152.942 71,147.5C 68.133,145.249 65.7997,142.583 64,139.5C 63.9495,136.132 64.4495,132.798 65.5,129.5C 63.421,125.007 61.0877,120.674 58.5,116.5C 59.9722,113.055 61.3055,109.555 62.5,106C 60.7532,103.02 60.2532,99.853 61,96.5C 62.6667,94.1667 64.3333,91.8333 66,89.5C 66.2148,86.1443 66.2148,82.811 66,79.5C 69.2199,76.043 72.8865,73.043 77,70.5C 77.2104,67.7658 78.0437,65.2658 79.5,63C 81.9552,61.6884 84.4552,60.5218 87,59.5C 88.0978,52.362 92.2644,49.1954 99.5,50C 106.904,43.4487 115.571,40.1154 125.5,40C 130.871,43.2409 135.871,42.7409 140.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 420.5,41.5 C 429.339,41.5871 436.672,44.9204 442.5,51.5C 452.564,43.2368 463.231,42.4035 474.5,49C 484.3,58.669 485.8,69.5024 479,81.5C 471.254,90.3883 461.754,92.8883 450.5,89C 446.742,87.0771 443.409,84.5771 440.5,81.5C 428.833,90.8333 417.167,90.8333 405.5,81.5C 395.845,92.1829 384.512,94.3496 371.5,88C 358.618,75.6268 358.284,62.9602 370.5,50C 381.769,43.4035 392.436,44.2368 402.5,52.5C 407.356,46.7485 413.356,43.0818 420.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 278.5,45.5 C 282.5,45.5 286.5,45.5 290.5,45.5C 291.917,138.157 292.917,230.824 293.5,323.5C 286.167,323.5 278.833,323.5 271.5,323.5C 273.367,230.807 275.701,138.14 278.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 311.5,45.5 C 315.767,45.203 319.934,45.5363 324,46.5C 325.153,138.831 325.986,231.164 326.5,323.5C 319.167,323.5 311.833,323.5 304.5,323.5C 306.634,230.826 308.967,138.159 311.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 419.5,52.5 C 432.516,52.6758 437.35,59.0092 434,71.5C 428.525,78.0374 422.025,79.204 414.5,75C 408.024,65.5961 409.691,58.0961 419.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 455.5,55.5 C 470.393,54.9647 475.226,61.6313 470,75.5C 463.333,82.1667 456.667,82.1667 450,75.5C 445.392,66.906 447.226,60.2393 455.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 129.5,56.5 C 137.605,57.5434 139.272,61.3767 134.5,68C 128.199,69.281 125.365,66.781 126,60.5C 126.69,58.6498 127.856,57.3164 129.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 380.5,56.5 C 395.393,55.9647 400.226,62.6313 395,76.5C 388.333,83.1667 381.667,83.1667 375,76.5C 370.674,67.9942 372.507,61.3276 380.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafbfb",
    d: "M 106.5,64.5 C 113.56,63.7253 116.06,66.7253 114,73.5C 110.667,77.5 107.333,77.5 104,73.5C 102.93,69.8579 103.764,66.8579 106.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfc",
    d: "M 150.5,68.5 C 159.244,68.4126 161.577,72.246 157.5,80C 151.761,82.464 148.094,80.6307 146.5,74.5C 146.866,71.7441 148.2,69.7441 150.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9f9",
    d: "M 88.5,80.5 C 95.4529,82.5487 96.7862,86.382 92.5,92C 85.8374,93.6664 83.0041,91.1664 84,84.5C 84.9066,82.3909 86.4066,81.0576 88.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 125.5,88.5 C 131.303,88.81 133.47,91.81 132,97.5C 128.714,101.485 125.381,101.485 122,97.5C 120.665,93.3919 121.832,90.3919 125.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfc",
    d: "M 173.5,88.5 C 181.098,88.3341 183.931,92.0008 182,99.5C 176.865,103.957 172.532,103.29 169,97.5C 168.377,93.4123 169.877,90.4123 173.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafa",
    d: "M 100.5,102.5 C 107.897,104.358 109.231,108.192 104.5,114C 98.2124,115.378 95.3791,112.878 96,106.5C 97.3968,104.93 98.8968,103.596 100.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 145.5,107.5 C 150.406,106.306 153.406,108.139 154.5,113C 151.891,119.242 148.057,120.075 143,115.5C 142.018,112.225 142.851,109.559 145.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafa",
    d: "M 76.5,107.5 C 81.6108,107.776 84.1108,110.443 84,115.5C 80.8295,120.414 77.1628,120.747 73,116.5C 71.9804,112.553 73.1471,109.553 76.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 186.5,116.5 C 192.33,116.161 194.83,118.827 194,124.5C 190.333,129.833 186.667,129.833 183,124.5C 182.279,120.946 183.446,118.28 186.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010202",
    d: "M 354.5,119.5 C 402.501,119.333 450.501,119.5 498.5,120C 499.163,136.428 499.497,152.928 499.5,169.5C 499.497,186.072 499.163,202.572 498.5,219C 450.168,219.5 401.834,219.667 353.5,219.5C 353.174,186.094 353.507,152.76 354.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9f9",
    d: "M 120.5,120.5 C 126.082,120.988 128.248,123.988 127,129.5C 124.833,132.287 121.999,133.12 118.5,132C 114.416,127.402 115.083,123.569 120.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 420.5,123.5 C 424.131,123.16 427.464,123.994 430.5,126C 433.372,128.537 435.872,131.37 438,134.5C 451.172,131.174 459.339,136.174 462.5,149.5C 467.233,150.35 471.9,151.517 476.5,153C 481.922,154.07 484.089,157.236 483,162.5C 475.398,180.526 464.231,196.026 449.5,209C 432.701,212.564 416.034,212.23 399.5,208C 381.774,196.421 370.441,180.254 365.5,159.5C 366.128,157.742 367.128,156.242 368.5,155C 373.182,152.413 378.182,150.913 383.5,150.5C 382.509,141.634 386.176,135.801 394.5,133C 399.557,132.958 404.557,132.792 409.5,132.5C 412.338,128.313 416.005,125.313 420.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfc",
    d: "M 86.5,131.5 C 92.8197,131.32 95.3197,134.32 94,140.5C 90.6667,144.5 87.3333,144.5 84,140.5C 82.9271,136.9 83.7605,133.9 86.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafa",
    d: "M 167.5,133.5 C 174.326,133.814 176.493,137.147 174,143.5C 166.577,147.081 163.244,144.748 164,136.5C 165.145,135.364 166.312,134.364 167.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000101",
    d: "M 421.5,134.5 C 423.903,134.393 425.736,135.393 427,137.5C 428.211,140.759 430.044,143.592 432.5,146C 436.597,145.919 440.597,145.086 444.5,143.5C 448.819,144.492 450.986,147.159 451,151.5C 446.135,153.531 441.969,156.531 438.5,160.5C 428.485,155.216 418.485,155.216 408.5,160.5C 404.279,157.222 399.612,154.722 394.5,153C 392.148,144.769 395.148,141.769 403.5,144C 407.673,146.921 411.506,146.755 415,143.5C 416.686,140.117 418.853,137.117 421.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafa",
    d: "M 139.5,137.5 C 147.935,136.864 150.268,140.364 146.5,148C 141.31,149.805 137.976,148.138 136.5,143C 137.124,140.915 138.124,139.082 139.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfc",
    d: "M 112.5,157.5 C 121.487,156.665 123.82,160.165 119.5,168C 110.802,168.773 108.468,165.273 112.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 456.5,160.5 C 460.915,160.305 465.249,160.805 469.5,162C 470.517,163.049 470.684,164.216 470,165.5C 463.802,178.372 455.302,189.538 444.5,199C 433.55,200.546 422.55,200.879 411.5,200C 408.711,199.759 406.044,199.092 403.5,198C 391.078,189.319 382.411,177.819 377.5,163.5C 377.709,162.914 378.043,162.414 378.5,162C 386.708,160.735 394.042,162.735 400.5,168C 400.033,173.129 400.533,178.296 402,183.5C 404.922,188.233 408.255,188.566 412,184.5C 409.073,169.761 414.906,164.261 429.5,168C 435.466,170.471 437.133,174.804 434.5,181C 437.279,187.493 440.779,187.993 445,182.5C 446.651,178.342 446.817,174.175 445.5,170C 448.153,165.503 451.82,162.337 456.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfc",
    d: "M 140.5,164.5 C 146.093,165.618 147.926,168.951 146,174.5C 138.203,178.278 134.87,175.944 136,167.5C 137.409,166.219 138.909,165.219 140.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000101",
    d: "M 22.5,220.5 C 95.8341,220.333 169.167,220.5 242.5,221C 242.523,258.71 242.523,296.543 242.5,334.5C 169.166,334.667 95.8326,334.5 22.5,334C 21.1696,296.167 21.1696,258.333 22.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 158.5,232.5 C 177.235,230.066 194.902,233.233 211.5,242C 230.063,253.697 236.896,270.197 232,291.5C 225.027,304.795 214.193,313.295 199.5,317C 189.204,319.895 178.704,321.062 168,320.5C 138.908,319.515 110.408,314.849 82.5,306.5C 74.542,314.149 65.542,320.316 55.5,325C 47.9921,326.141 45.4921,322.974 48,315.5C 49.1027,309.82 50.2694,304.153 51.5,298.5C 46.598,291.423 41.098,284.756 35,278.5C 34.161,275.86 34.661,273.527 36.5,271.5C 40.6154,270.864 44.7821,270.53 49,270.5C 57.5376,270.913 66.0376,271.413 74.5,272C 98.723,250.867 126.723,237.7 158.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010202",
    d: "M 354.5,233.5 C 402.501,233.333 450.501,233.5 498.5,234C 499.163,250.594 499.497,267.261 499.5,284C 499.497,300.739 499.163,317.406 498.5,334C 450.168,334.5 401.834,334.667 353.5,334.5C 353.174,300.76 353.507,267.094 354.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 164.5,242.5 C 166.167,242.5 167.833,242.5 169.5,242.5C 159.422,267.168 163.422,289.168 181.5,308.5C 181.291,309.086 180.957,309.586 180.5,310C 162.683,310.774 145.016,309.441 127.5,306C 111.578,302.894 95.7446,299.394 80,295.5C 75.7153,296.438 72.5486,298.938 70.5,303C 67.6397,305.36 64.6397,307.527 61.5,309.5C 61.1667,308.667 60.8333,307.833 60.5,307C 61.7918,302.555 62.2918,298.055 62,293.5C 58.643,289.644 55.4763,285.644 52.5,281.5C 60.0605,281.238 67.5605,282.238 75,284.5C 100.437,261.199 130.271,247.199 164.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 181.5,243.5 C 200.7,244.905 214.2,254.239 222,271.5C 225.025,281.903 222.525,290.736 214.5,298C 208.658,302.927 201.992,305.594 194.5,306C 174.476,288.429 170.143,267.596 181.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 396.5,249.5 C 413.433,249.42 429.1,253.92 443.5,263C 447.167,265.5 450.833,268 454.5,270.5C 465.498,263.501 477.165,257.835 489.5,253.5C 494.15,254.266 495.65,256.932 494,261.5C 490.41,269.512 487.243,277.679 484.5,286C 487.632,295.728 490.965,305.395 494.5,315C 493.682,318.901 491.349,320.568 487.5,320C 477.419,314.544 467.586,308.711 458,302.5C 444.183,311.938 429.016,317.938 412.5,320.5C 387.769,318.736 369.602,307.069 358,285.5C 357.333,284.5 357.333,283.5 358,282.5C 367.366,267.29 380.199,256.29 396.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9fbfb",
    d: "M 145.5,253.5 C 149.057,253.497 151.224,255.163 152,258.5C 152.647,269.031 153.481,279.531 154.5,290C 152.795,296.774 149.295,297.941 144,293.5C 142.491,281.198 141.824,268.865 142,256.5C 143.145,255.364 144.312,254.364 145.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 121.5,259.5 C 124.368,259.085 126.535,260.085 128,262.5C 128.783,271.72 130.617,280.72 133.5,289.5C 132.807,294.151 130.141,295.651 125.5,294C 119.958,284.26 117.791,273.76 119,262.5C 119.698,261.309 120.531,260.309 121.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 410.5,260.5 C 424.873,264.353 437.873,270.853 449.5,280C 451.034,280.923 452.701,281.423 454.5,281.5C 462.64,278.18 470.473,274.18 478,269.5C 476.828,274.859 475.328,280.192 473.5,285.5C 474.56,290.679 476.226,295.679 478.5,300.5C 477.635,301.583 476.635,301.749 475.5,301C 469.89,297.029 463.89,293.862 457.5,291.5C 448.583,295.958 439.583,300.458 430.5,305C 424.268,307.466 417.934,309.633 411.5,311.5C 411.167,311 410.833,310.5 410.5,310C 416.155,293.802 415.822,277.802 409.5,262C 410.056,261.617 410.389,261.117 410.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 394.5,261.5 C 395.873,261.343 397.207,261.51 398.5,262C 408.098,274.426 409.931,287.926 404,302.5C 400.522,306.662 396.356,307.496 391.5,305C 381.821,300.654 374.821,293.654 370.5,284C 376.772,274.559 384.772,267.059 394.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfc",
    d: "M 195.5,264.5 C 201.279,264.112 203.779,266.778 203,272.5C 198.837,276.747 195.171,276.414 192,271.5C 191.576,268.348 192.743,266.014 195.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafbfb",
    d: "M 99.5,270.5 C 102.157,270.162 104.49,270.829 106.5,272.5C 107.45,277.852 109.283,282.852 112,287.5C 113.577,292.079 112.077,295.079 107.5,296.5C 102.124,293.439 98.9575,288.772 98,282.5C 95.5429,278.049 96.0429,274.049 99.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfc",
    d: "M 386.5,276.5 C 391.5,277.155 393.167,279.822 391.5,284.5C 387.112,287.653 384.112,286.653 382.5,281.5C 383.127,279.213 384.46,277.546 386.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 22.5,348.5 C 73.5,348.5 124.5,348.5 175.5,348.5C 175.5,380.833 175.5,413.167 175.5,445.5C 146.165,445.667 116.831,445.5 87.5,445C 47.363,436.861 25.5296,412.361 22,371.5C 21.2019,363.754 21.3686,356.087 22.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 190.5,348.5 C 239.168,348.333 287.834,348.5 336.5,349C 337.496,381.093 337.829,413.26 337.5,445.5C 288.5,445.5 239.5,445.5 190.5,445.5C 190.5,413.167 190.5,380.833 190.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 352.5,348.5 C 401.168,348.333 449.834,348.5 498.5,349C 503.621,379.97 494.954,406.304 472.5,428C 461.08,437.208 448.08,442.875 433.5,445C 406.502,445.5 379.502,445.667 352.5,445.5C 352.5,413.167 352.5,380.833 352.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfc",
    d: "M 358.5,360.5 C 396.839,360.167 435.172,360.5 473.5,361.5C 472.142,379.414 465.976,395.414 455,409.5C 430.208,433.855 404.874,434.521 379,411.5C 367.216,396.584 360.383,379.584 358.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 95.5,365.5 C 109.728,365.742 122.394,370.242 133.5,379C 146.632,390.465 156.965,403.965 164.5,419.5C 163.608,422.898 161.442,424.565 158,424.5C 146.901,422.6 135.735,422.1 124.5,423C 114.68,424.29 104.847,425.457 95,426.5C 82.0808,426.118 70.5808,421.952 60.5,414C 48.4101,403.087 38.4101,390.587 30.5,376.5C 31.5,373.5 33.5,371.5 36.5,370.5C 44.0136,375.961 52.347,378.128 61.5,377C 68.3921,374.887 75.0587,372.22 81.5,369C 86.2242,367.506 90.8909,366.339 95.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 258.5,369.5 C 264.945,369.463 271.278,370.296 277.5,372C 285.055,375.277 292.722,378.277 300.5,381C 309.555,381.818 317.889,379.652 325.5,374.5C 330.077,375.921 331.577,378.921 330,383.5C 322.345,395.83 313.178,406.996 302.5,417C 292.135,425.675 280.135,430.175 266.5,430.5C 248.638,427.184 230.638,426.017 212.5,427C 209.5,427.5 206.5,428 203.5,428.5C 198.46,428.094 196.626,425.428 198,420.5C 207.326,403.509 219.826,389.342 235.5,378C 242.745,373.645 250.412,370.812 258.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000101",
    d: "M 417.5,370.5 C 432.324,370.018 446.99,370.518 461.5,372C 458.088,388.841 449.422,402.175 435.5,412C 408.501,422.998 389.001,415.164 377,388.5C 374.867,383.268 373.034,377.934 371.5,372.5C 386.995,371.833 402.328,371.167 417.5,370.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfc",
    d: "M 387.5,375.5 C 394.574,375.161 401.574,375.661 408.5,377C 400.2,383.773 390.867,386.439 380.5,385C 377.92,382.88 377.92,380.713 380.5,378.5C 382.885,377.339 385.219,376.339 387.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9fbfb",
    d: "M 430.5,375.5 C 437.674,375.012 444.674,375.845 451.5,378C 455.835,381.307 455.502,383.974 450.5,386C 440.692,386.397 432.025,383.397 424.5,377C 426.708,376.809 428.708,376.309 430.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000101",
    d: "M 93.5,376.5 C 112.431,376.466 127.431,384.132 138.5,399.5C 138.167,399.833 137.833,400.167 137.5,400.5C 118.312,390.762 97.9785,386.596 76.5,388C 73.9406,391.075 73.9406,394.075 76.5,397C 96.5461,397.262 115.546,401.762 133.5,410.5C 119.302,413.362 104.968,414.862 90.5,415C 74.239,411.914 61.5723,403.414 52.5,389.5C 56.8423,388.703 61.1756,387.87 65.5,387C 74.8359,383.151 84.1693,379.651 93.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfdfd",
    d: "M 409.5,379.5 C 410.497,379.47 411.164,379.97 411.5,381C 409.582,390.188 404.916,397.521 397.5,403C 394.443,403.981 392.443,402.981 391.5,400C 392.137,397.755 392.97,395.588 394,393.5C 398.765,388.228 403.931,383.561 409.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 257.5,380.5 C 262.899,380.309 268.233,380.809 273.5,382C 284.894,387.742 296.894,391.576 309.5,393.5C 299.042,409.291 284.376,417.958 265.5,419.5C 252.829,418.047 240.162,416.547 227.5,415C 245.322,405.795 264.322,401.128 284.5,401C 288.057,398.419 288.39,395.419 285.5,392C 263.939,390.345 243.606,394.512 224.5,404.5C 223.479,403.998 223.312,403.332 224,402.5C 232.914,391.477 244.08,384.144 257.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafbfb",
    d: "M 415.5,380.5 C 417.284,381.574 418.451,383.24 419,385.5C 421.322,392.332 421.988,399.332 421,406.5C 418.333,411.833 415.667,411.833 413,406.5C 412.5,404 412,401.5 411.5,399C 412.443,392.73 413.776,386.563 415.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 421.5,379.5 C 429.799,383.564 436.299,389.564 441,397.5C 442.5,402.667 440.667,404.5 435.5,403C 428.171,396.856 423.504,389.022 421.5,379.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreppyLogo);
export default __webpack_public_path__ + "static/media/preppy-logo.1a049f9bbf2293725d07821f5dff090f.svg";
export { ForwardRef as ReactComponent };